import * as v from 'valibot';
import Ajax from '../util/ajax';
import { deviceUpdated } from '../features/devices/devicesSlice';
import { hideDialog } from '../reducers/app';
import { transmitterSchema } from '../types/transmitter';
export function saveTransmitter() {
    return (dispatch, getState) => {
        const { edit_transmitter_dialog } = getState();
        const ajax = new Ajax(dispatch);
        const url = '/transmitter/' + edit_transmitter_dialog.id;
        const obj = Object.assign({}, edit_transmitter_dialog);
        ajax.post(url, obj, data => {
            const res = v.safeParse(transmitterSchema, data);
            if (res.success) {
                const transmitter = res.output;
                let device_protocol;
                switch (transmitter.kind) {
                    case 'onoff':
                        device_protocol = {
                            name: 'nexa transmitter',
                            kind: 'onoff',
                            code: transmitter.code,
                            unit: transmitter.unit,
                        };
                        break;
                    case 'dim':
                        device_protocol = {
                            name: 'nexa transmitter',
                            kind: 'dimmer',
                            code: transmitter.code,
                            unit: transmitter.unit,
                        };
                        break;
                    case 'rollershade':
                        device_protocol = {
                            name: 'hasta transmitter',
                            code: transmitter.code,
                            unit: transmitter.unit,
                        };
                        break;
                }
                if (device_protocol != undefined) {
                    const device = {
                        id: transmitter.id,
                        title: transmitter.title,
                        comment: transmitter.comment,
                        protocol: device_protocol,
                        transmitter_kind: transmitter.kind,
                    };
                    dispatch(deviceUpdated(device));
                }
            }
            else {
                console.error(v.summarize(res.issues));
            }
            dispatch(hideDialog());
        });
    };
}
